module.exports = __webpack_public_path__ + "soap-icons.f8dadf5823ebe5f3afca.eot";


//////////////////
// WEBPACK FOOTER
// D:/ptrans/front-end-customer/src/assets/fonts/soap-icons.eot?26664784
// module id = ../../../../../src/assets/fonts/soap-icons.eot?26664784
// module chunks = 2